import type { ShopMetaQueryResponse } from '~/api/graphql/queries/shopMeta.generated';
import type { IShopMetaCampaignTemplate } from '~/types/shopMeta';
import type { IShopMeta } from '~/stores/shopMeta';

import { META_KEY_CAMPAIGN_TEMPLATE } from '~/constants/shopMeta';
import { captureSentryError } from '~/exceptions/sentry';

export const findShopMetaByKey = (data: ShopMetaQueryResponse, key: string) => {
  return data?.shopMeta?.edges?.find((item) => item?.node?.key === key);
};

export const mapShopMetaData = (data: ShopMetaQueryResponse): IShopMeta[] | undefined => {
  const newData = data?.shopMeta?.edges
    ?.map((item) => {
      const node = item?.node;
      if (!node) return undefined;

      return {
        key: node.key,
        value: node.value,
      } as IShopMeta;
    })
    .filter((item) => !!item);

  return newData;
};

export const findAndParseShopMeta = <T>(shopMeta: IShopMeta[], key: string): T | undefined => {
  try {
    const shopMetaItem = shopMeta?.find((item) => item.key === key);
    return shopMetaItem ? JSON.parse(shopMetaItem.value) : undefined;
  } catch (error) {
    captureSentryError(error, {
      source: 'findAndParseShopMetaError',
      tags: { app: 'App' },
    });
    return undefined;
  }
};

export const updateCampaignTemplateMeta = async (
  shopMeta: IShopMeta[] | undefined,
  shopMetaMutation: any, // Ideally, you would replace `any` with the correct type
): Promise<void> => {
  if (!shopMeta) return;

  const shopMetaCampaignTemplate = findAndParseShopMeta<IShopMetaCampaignTemplate>(
    shopMeta,
    META_KEY_CAMPAIGN_TEMPLATE,
  );

  const updatedValue = {
    ...shopMetaCampaignTemplate,
    isFirstActiveCampaign: true,
  };

  await shopMetaMutation.mutateAsync({
    input: {
      key: META_KEY_CAMPAIGN_TEMPLATE,
      value: JSON.stringify(updatedValue),
    },
  });
};
